import { render, staticRenderFns } from "./TargetStorage.vue?vue&type=template&id=8f5f73c6&"
import script from "./TargetStorage.vue?vue&type=script&lang=js&"
export * from "./TargetStorage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports